import { Box } from '@mui/material';
import { UserBalance } from '../../../../@types';
import { useUpdateCredits } from '../../../../hooks/useUpdateCredits';
import useLocalization from '../../../../hooks/useLocalization';
import FormNumberInput from '../../../molecules/form-elements/FormNumberInput';
import StyledForm from '../molecules/StyledForm';
import { styledFormInputStyles } from '../molecules/StyledFormInput';

const BalanceAdjustmentForm = ({
  userBalanceData,
  handleUpdate,
}: {
  userBalanceData: UserBalance;
  handleUpdate: () => void;
}) => {
  const { t } = useLocalization();
  const { onSubmit, isSubmitting, handleSubmit, errors, control } = useUpdateCredits(userBalanceData, handleUpdate);

  return (
    <Box component='form' onSubmit={handleSubmit(onSubmit)} sx={{ width: '100%' }}>
      <StyledForm isSubmitting={isSubmitting} headingText={t('transferBalance') + ` ${userBalanceData.currency}`}>
        <FormNumberInput
          name='amount'
          control={control}
          allowNegative
          autoFocus
          disabled={isSubmitting}
          error={!!errors.amount}
          fullWidth
          helperText={errors.amount?.message}
          slotProps={{
            input: { disableUnderline: true },
            htmlInput: { inputMode: 'text' },
          }}
          placeholder={t('amount')}
          sx={styledFormInputStyles.numberInput}
          variant='standard'
        />
      </StyledForm>
    </Box>
  );
};
export default BalanceAdjustmentForm;
